import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";

import "element-ui/lib/theme-chalk/index.css";
import "./plugins/element";

// 全局混入写法
import myMixin from "./mixin/index";
Vue.mixin(myMixin);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
